import React from 'react';
import PropTypes from 'prop-types';
import CarouselWrapper from '../../components/CarouselWrapper';

const SlideSummary = ({ children, ...otherProps }) => (
  <CarouselWrapper
    {...otherProps}
    modifier="slide-summary"
    pauseScrollOnHover
    enableAutoScroll
    autoScrollTimer={3500}>
    {children}
  </CarouselWrapper>
);

SlideSummary.propTypes = {
  children: PropTypes.object.isRequired
};

export default SlideSummary;
